<template>
  <f7-page
    name="completar"
  >
    <f7-navbar
      :sliding="false"
    >
      <!-- <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link> -->
      <f7-nav-title class="text-madai">Anillo Completo</f7-nav-title>
      <f7-nav-right>
        <!-- <f7-link class="text-white" icon-md="material:search" @click="activarBusqueda = true"></f7-link> -->
      </f7-nav-right>
    </f7-navbar>

    <div class="mobile-funnel-container m-t-20">
      <ul class="mobile-funnel show">
        <li class="Ring" style="width:30%;">
          <img src="assets/img/otros/check.png" alt="" width="18" style="position: absolute; right: 0; top: 10px;">
          <f7-link href="/compromiso/">
            <div></div>
          </f7-link>
        </li>
        <li class="Diamond">
            <img src="assets/img/otros/check.png" alt="" width="18" style="position: absolute; right: 0; top: 10px;">
          <f7-link href="/diamantes/">
            <div></div>
          </f7-link>
        </li>
        <li class="Complete complete active">
          <div></div>
        </li>
      </ul>
    </div>

    <f7-block>
      <hr class="m-t-20">
      <f7-row>
        <f7-col width="35">
          <img class="wd-100" :src="`//madai.mx/assets/images/${montura.image}`" alt="">
        </f7-col>
        <f7-col width="65" class="fs-15 p-t-15">
          <f7-row>
            <span class="bold">Laterales</span> {{ $helper.str.capitalizar(montura.cuts_lateral_stone) }}
          </f7-row>
          <f7-row>
            <span class="bold">Claridad</span> {{ montura.m_clarity }}
          </f7-row>
          <f7-row>
            <span class="bold">Color</span> {{ $helper.str.capitalizar(montura.color) }}
          </f7-row>
          <f7-row>
            <span class="bold">Peso</span> {{ montura.m_weight }}
          </f7-row>
          <f7-row>
            <span class="bold">Montura</span> {{ $helper.str.formatearMoneda(montura.price) }}
          </f7-row>
        </f7-col>
      </f7-row>
      <f7-row class="m-t-15">
        <f7-col>
          <f7-button href="/compromiso/" @click="storage.montura = ''" class="text-white" color="blue" small fill raised sheet-close>Cambiar</f7-button>
        </f7-col>
      </f7-row>
      <hr class="m-t-20 m-b-20">
      <f7-row>
        <f7-col width="35 m-t-15">
          <img class="wd-100" :src="`//madai.mx/img/diamond/redondo.png`" alt="">
        </f7-col>
        <f7-col width="65" class="fs-15">
          <f7-row>
            <span class="bold">Forma</span> {{ $helper.str.capitalizar(diamante.Cut) }}
          </f7-row>
          <f7-row>
            <span class="bold">Carat</span> {{ diamante.Carat }}
          </f7-row>
          <f7-row>
            <span class="bold">Claridad</span> {{ diamante.Clarity }}
          </f7-row>
          <f7-row>
            <span class="bold">Color</span> {{ diamante.Color }}
          </f7-row>
          <f7-row>
            <span class="bold">Corte</span> {{ diamante.MakeCutGrade }}
          </f7-row>
          <f7-row>
            <span class="bold">Medida</span> {{ diamante.Measurements }}
          </f7-row>
          <f7-row>
            <span class="bold">Precio</span> {{ $helper.str.formatearMoneda(diamante.Price) }}
          </f7-row>
        </f7-col>
      </f7-row>
      <f7-row class="m-t-15">
        <f7-col>
          <f7-button href="/diamantes/" @click="storage.diamante = ''" class="text-white" color="blue" small fill raised sheet-close>Cambiar</f7-button>
        </f7-col>
      </f7-row>
      <hr class="m-t-20 m-b-20">
      <div class="bold text-center p-10 alert alert-secondary">
        Total del anillo {{ $helper.str.formatearMoneda(montura.price + diamante.Price) }}, iva incluido.
      </div>
      <f7-button class="margin-auto text-white" fill href="/compromiso/" @click="agregarCarrito()">
        Agregar a carrito
      </f7-button>
    </f7-block>

    <navbar-bottom />
  </f7-page>
</template>

<script>
import navbarBottom from '@/components/navbar-bottom'

export default {
  components: {
    navbarBottom
  },
  data () {
    return {
      filtro: '',
      montura: {},
      diamante: {}
    }
  },
  watch: {
    storage: {
      handler (val) {
        this.init()
      },
      deep: true
    }
  },
  methods: {
    async init () {
      if (this.storage.montura !== '') {
        this.montura = await this.$api.catalogo.detallesCompromiso(this.storage.montura)
      } else {
        this.montura = {}
      }

      if (this.storage.diamante !== '') {
        this.diamante = await this.$api.catalogo.detallesDiamante(this.storage.diamante)
      } else {
        this.diamante = {}
      }
    },
    agregarCarrito () {
      this.montura.price += this.diamante.Price
      this.storage.carrito.push(Object.assign({}, this.montura, { diamante: this.diamante }))
      // this.storage.carrito.push(Object.assign({}, this.montura))
      // this.storage.carrito.push(Object.assign({}, this.diamante))
      this.storage.montura = ''
      this.storage.diamante = ''
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>
.mobile-funnel{clear:both;height:33px;line-height:33px;margin:0;table-layout:fixed;text-align:center;width:100%;box-sizing:border-box;border:2px solid #111427;border-radius:4px;}
.mobile-funnel.show{display:table!important;margin-bottom:.5em;z-index:10;position:relative;}
.mobile-funnel>li .dropdown{display:none;}
.mobile-funnel>li{cursor:pointer;display:table-cell;height:100%;position:relative;}
.mobile-funnel>li.active{background-color:#293061;color:#fff;}
.mobile-funnel>li.Ring div::before{content:"Montura";}
.mobile-funnel>li.Diamond div::before{content:"Diamante";}
.mobile-funnel>li.complete div::before,.mobile-funnel>li.Complete div::before{content:"Completar";}
.mobile-funnel>li div::before{content:attr(step);}
.mobile-funnel>li:not(:last-child)::before{border-color:transparent transparent transparent #111427;border-style:solid;border-width:18px 0 18px 15px;content:"";position:absolute;right:-15px;top:-1px;z-index:9;}
.mobile-funnel>li:not(:last-child)::after{border-color:transparent transparent transparent #fff;border-style:solid;border-width:16px 0 16px 13px;content:"";position:absolute;right:-13px;top:1px;z-index:9;}
.mobile-funnel>li.active:not(:last-child)::after{border-color:transparent transparent transparent #293061;}
a{text-decoration:none;color:inherit;}
.mobile-funnel-container{width:95%;margin:0 auto;}
ul{padding:0;list-style:none;}
li,ul{padding:0;margin:0;}
li,ul{list-style:none;}
a{text-decoration:none;}
:focus{outline:none;}
</style>
